import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {DeleteSmsDripEdition as DeleteSmsDripEditionMutation} from 'nutshell-graphql-types';

import DELETE_SMS_DRIP_EDITION from '../mutations/delete-sms-drip-edition.graphql';

export function useDeleteSmsDripEdition(): {
    deleteDripEdition: (id: string) => Promise<any>;
    isDeleting: boolean;
    error: string | null | undefined;
} {
    const [deleteDripEdition, {loading, error}] = useMutation<
        DeleteSmsDripEditionMutation,
        Record<any, any>
    >(DELETE_SMS_DRIP_EDITION);

    return {
        deleteDripEdition: (id: string) =>
            deleteDripEdition({
                variables: {input: {id}},
            }),
        isDeleting: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
